/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import {
	performCmdbGetRequest,
	performCmdbPutRequest,
} from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getDataManagerProvisioningStatusUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getDataManagerProvisioningStatusUrl.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ActionApi, ProvisioningStatusResponse } from './ActionApi.types.tsx';

type UpdateProvisioningStatusParams = {
	isEnabled: boolean;
};

export const updateProvisioningStatus =
	({ isEnabled }: UpdateProvisioningStatusParams): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		if (state.dataManager.provisioningUpdateLoading) {
			return;
		}

		setState({
			...state,
			dataManager: {
				...state.dataManager,
				isProvisioned: isEnabled,
				provisioningUpdateLoading: true,
			},
		});

		try {
			const requestBody = {
				enabled: isEnabled,
			};

			await performCmdbPutRequest(getDataManagerProvisioningStatusUrl(workspaceId), {
				body: JSON.stringify(requestBody),
			});

			const result: ProvisioningStatusResponse = await performCmdbGetRequest(
				getDataManagerProvisioningStatusUrl(workspaceId),
			);

			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								isProvisioned: result.enabled === 'ON',
								provisioningUpdateLoading: false,
							},
						}
					: {
							...state,
							dataManager: {
								...state.dataManager,
								isProvisioned: result.enabled === 'ON',
								provisioningUpdateLoading: false,
							},
						},
			);
			fireTrackAnalytics(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');

			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								provisioningUpdateLoading: false,
								provisioningUpdateError: error,
							},
						}
					: {
							...state,
							dataManager: {
								...state.dataManager,
								provisioningUpdateLoading: false,
								provisioningUpdateError: error,
							},
						},
			);

			fireCmdbErrorAnalytics({
				meta: {
					id: 'updateProvisioningStatus',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
				},
				error,
			});

			throw error;
		}
	};
